import styled from '@emotion/styled';
import { RacemapColors } from '@racemap/utilities/consts/common';
import { Tree as ATree } from 'antd';
import type { DataNode } from 'antd/es/tree';
import type { FC, Key } from 'react';
import { useStore } from '../../../store/reducers';
import { Filters } from './FilterTreeFunctions';
import { prepareFilterSubTreeComponentMapping } from './prepareFilterSubTreeComponentMapping';

export const FilterTree: FC = () => {
  const checkedKeys = Array.from(useStore((s) => s.trackers.filterSet)).map((key) =>
    key.startsWith('/') ? key.substring(1) : key,
  );
  const { setFilterSet } = useStore((s) => s.trackers.actions);

  const filterSubTreeComponentMapping = prepareFilterSubTreeComponentMapping();

  const onCheck = (checked: Array<Key> | { checked: Array<Key>; halfChecked: Array<Key> }) => {
    const checkedKeysValue = Array.isArray(checked) ? checked : checked.checked;
    const modifiedKeys = checkedKeysValue.map((key) => `/${key}`);
    setFilterSet(new Set<string>(modifiedKeys));
  };

  const treeData: Array<DataNode> = Object.values(filterSubTreeComponentMapping);

  return (
    <Tree
      checkable
      treeData={treeData}
      showLine
      multiple
      onCheck={onCheck}
      checkedKeys={checkedKeys}
      defaultExpandedKeys={[
        Filters.Tags,
        Filters.Online,
        Filters.Messages,
        Filters.Location,
        Filters.Battery,
        Filters.Logistics,
        Filters.LastDataAt,
      ]}
    />
  );
};

const Tree = styled(ATree)`
  .ant-tree-node-content-wrapper {
    width: 100%;
  }

  .ant-tree-treenode:hover .ant-tree-node-content-wrapper {
    background-color: ${RacemapColors.CloudBlue};

    &:hover .toolbar {
    display: flex;
  }
  }

  .ant-tree-checkbox-disabled {
    display: none;
  }

  .ant-tree-treenode {
    width: 100%;
  }
`;
